<template>
  <div>
    <h1>{{ $t("message.slideFiveTitle") }}</h1>
    <br /><br />
    <p>
      {{ $t("message.slideFiveListTitle") }} <br /><br />
      1. <span style="color: blue">{{ $t("message.slideFiveFirstItem") }}</span
      ><br /><br />
      2.
      <span style="color: blue">{{ $t("message.slideFiveSecondItem") }}</span
      ><br /><br />
      3. <span style="color: blue">{{ $t("message.slideFiveThirdItem") }}</span
      ><br /><br />
      4.
      <span style="color: blue">{{ $t("message.slideFiveFourthItem") }}</span
      ><br /><br />
      5.
      <span style="color: blue">{{ $t("message.slideFiveFifthItem") }}</span>
    </p>
  </div>
</template>
<script>
export default {
  name: "WorkshopFormat",
  props: {
    file: { type: String },
    slideNumber: { type: Number },
    updateFile: { type: Function }
  },
  data() {
    return {
      audio: null,
      newSlideNumber: null
    };
  },
  watch: {
    "$i18n.locale": function() {
      if (this.newSlideNumber === 4) {
        this.audio.pause();
        this.audio.currentTime = 0;
        this.updateFile(4);
        this.audio = new Audio(this.file);
        this.audio.play();
      }
    },
    slideNumber(current) {
      this.newSlideNumber = current;
      if (current !== 4) {
        this.audio.pause();
        this.audio.currentTime = 0;
      } else {
        this.audio = new Audio(this.file);
        this.audio.play();
      }
    }
  },
  mounted() {
    this.newSlideNumber = this.slideNumber;
    this.audio = new Audio(this.file);
    this.audio.play();
  }
};
</script>
